import React, { PureComponent } from 'react';
import styles from './Nav.module.css';
import PropTypes from 'prop-types';

export default class Nav extends PureComponent {
  state = {
    active: 0,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    const { router } = this.context;
    const { catogary } = this.props;
    const path = router.route.location.pathname.replace(/\//g, '');
    let idx = catogary.map(item => item.toLowerCase()).indexOf(path);
    if (idx < 0) idx = 0;
    this.setState({ active: idx });
  }

  navTo = (idx, v) => {
    const { router } = this.context;
    this.setState({ active: idx });
    router.history.push(`/${v.toLowerCase()}`);
  };

  render() {
    const { catogary, notifications } = this.props;
    const { active } = this.state;
    return (
      <div className={styles.container}>
        {catogary.map((v, idx) => (
          <div
            key={v}
            className={active === idx ? styles.active : styles.catogary}
            onClick={() => this.navTo(idx, v)}
          >
            {v}
          </div>
        ))}
        {/* <div className={styles.notificationLister}>
          <img
            className={styles.notificationIcon}
            width="25"
            height="25"
            src="/img/notification.svg"
          />
          <div className={styles.notificationText}>
            {notifications.length} notifications
          </div>
        </div> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Nav/index.js